import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';

import Box from 'components/box';
import DoctorsList from './doctors-list';
import {SearchFail, SelectWithSearchAsync, Label,
  UniversalSearchWrapper, UniversalSelectWrapper} from 'components/common';
import Pagination from 'pagination';
import {ButtonDefault, LinkDefault} from 'components/buttons';
import {PageHead} from 'components/header/components';
import Input from 'form/input';
import Spinner from 'spinner';

import {searchDoctors, loadProfessions} from 'redux/actions/admin/doctors';


const mapStateToProps = (state) => ({
  doctors: state.doctors.get('doctorsList'),
  isLoading: state.doctors.get('doctorsAreLoading'),
  professions: state.doctors.get('professionsList'),
  isLoadingProfessions: state.doctors.get('professionsAreLoading')
});

const mapDispatchToProps = (dispatch) => ({
  loadProfessions: search => dispatch(loadProfessions(search)),
  onSearch: (name, profession, limit, offset) => dispatch(searchDoctors(name, profession, 25, offset))
});


class DoctorsAll extends Component {

  state = {
    name: '',
    profession: '',
    professionSelect: ''
  }

  selectStyle = {
    border: 'none'
  }

  changeSearchName = (event) => {
    this.setState({
      name: event.target.value
    })
  }

  onChangeProfession = profession => {
    let professionValue = profession ? profession.value : ''
    this.setState({
      professionSelect: profession,
      profession: professionValue
    });
  }

  onSubmitForm = event => {
    event.preventDefault();
    this.props.match.params.page != 1
      ? this.props.history.push(`/admin/doctors/1`)
      : this.props.onSearch(this.state.name, this.state.profession)
  }

  generateProfessionOptions = results => {
    return results.reduce((arr, item) => {
      const newOption =  {
        value: item.getIn(['id']),
        label: `${item.get('profession_title')}`
      }
      arr.push(newOption)
      return arr
    }, [])
  }

  loadProfession = search => {
    if (!search) search=''
    return this.props.loadProfessions(search)
      .then(response => {
        const results = response.get('results');
        if(!results.size) return Promise.resolve({ options: [] })
        const options = this.generateProfessionOptions(results)
        return { options }
      })
  }

  componentDidMount() {
    const page = this.props.match.params.page || 1;
    const limit = 25
    const offset = limit * (page - 1);
    this.props.onSearch(this.state.name, this.state.profession, limit, offset)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.page !== nextProps.match.params.page) {
      const limit = 25
      const page = nextProps.match.params.page || 1;
      const offset = limit * (page - 1);
      this.props.onSearch(this.state.name, this.state.profession, limit, offset)
    }
  }

  render() {

    if (this.props.isLoading && !this.props.doctors) return <Spinner/>;

    return(
      <div>
      <Box>
        <PageHead>
          <h2>Реєстр лікарів</h2>
          <LinkDefault to="/admin/doctors/create">Додати лікаря</LinkDefault>
        </PageHead>

        <UniversalSearchWrapper onSubmit={this.onSubmitForm}>
        <Input
          bottom="bottom"
          block
          placeholder="Введіть прізвище"
          label="Пошук за прізвищем"
          value={this.state.name}
          onChange={this.changeSearchName}
          style={this.inputDoc}
        />

          <UniversalSelectWrapper>
            <Label>Виберіть спеціальність:</Label>
            <SelectWithSearchAsync
              searchable={true}
              isSearchable={true}
              value={this.state.professionSelect}
              loadOptions={this.loadProfession}
              valueKey={'value'}
              labelkey={'label'}
              onChange={this.onChangeProfession}
              style={ this.selectStyle }
              placeholder="Почніть вводити для пошуку..."
              noResultsText="Немає результатів"
            />
          </UniversalSelectWrapper>

          <ButtonDefault type="submit" value="Пошук" />
        </UniversalSearchWrapper>

        {this.props.doctors.get('results') && this.props.doctors.get('results').size > 0
            ? (<div>
              {
                this.props.isLoading
                  ? (<Spinner/>)
                  : (<DoctorsList doctors={this.props.doctors.get('results')}/>)
              }

            </div>)
            : (
              <SearchFail>Лікарі відсутні</SearchFail>
            )}

        <Pagination counts={this.props.doctors.get('count')} path={`/admin/doctors/`} matched={this.props.match.params.page} limits={25}/>
      </Box>
    </div>
    )
  }
}

export default  withRouter(connect(mapStateToProps, mapDispatchToProps)(DoctorsAll));



// WEBPACK FOOTER //
// ./src/admin/doctors/doctors.js